import { Icon, IconName } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";
import classNames from "classnames";

import styles from "./EmptyState.module.css";

type EmptyStateProps = {
  children?: React.ReactNode;
  description?: string;
  icon?: IconName;
  title?: string;
  variant?: "fill" | "outline";
};

export const EmptyState = ({
  children,
  description,
  icon = "statusFilter",
  title = "Not finding what you need?",
  variant = "fill",
}: EmptyStateProps) => {
  return (
    <div className={classNames(styles.root, styles[variant])}>
      <Icon name={icon} size={48} color="GrayWarm6" />
      <Text tag="h3" type="SectionHeader" className={styles.title}>
        {title}
      </Text>
      {description && (
        <Text type="Body1" className={styles.description}>
          {description}
        </Text>
      )}
      {children}
    </div>
  );
};
